import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getBusinessView = createAsyncThunk(
  "business/getBusinessView",
  async (statusId) => {
    const formattedStatusId = Array.isArray(statusId) ? statusId.join(",") : statusId;
    const response = await axios.get(
      `/api/admin/getBusiness?statusId=${formattedStatusId}`
    );
    return response.response;
  }
);

export const getBusDetailedView = createAsyncThunk(
  "business/getBusDetailedView",
  async ({ orgId, dealCategoryId } = {}) => {
    const params = new URLSearchParams();
    if (orgId) params.append("orgId", orgId);
    if (dealCategoryId) params.append("dealCategoryId", dealCategoryId);
    const response = await axios.get(
      `/api/admin/getBusDetailedView?${params.toString()}`
    );
    return response.response;
  }
);

export const getBusinessSuppliers = createAsyncThunk(
  "business/getBusinessSuppliers",
  async (orgId) => {
    const response = await axios.get(
      `/api/admin/getBusinessSuppliers?orgId=${orgId}`
    );
    return response.response;
  }
);

export const createBusinessSupplier = createAsyncThunk(
  "business/createBusinessSupplier",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/admin/createBusinessSupplier",
        payload
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const updateBusinessSupplier = createAsyncThunk(
  "business/updateBusinessSupplier",
  async ({ supplierId, ...payload }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `/api/admin/updateBusinessSupplier/${supplierId}`,
        payload
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const verifySupplierPan = createAsyncThunk(
  "business/verifySupplierPan",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/admin/suppliers/verify-pan",
        payload
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "Failed to verify PAN");
    }
  }
);

export const verifySupplierGstin = createAsyncThunk(
  "business/verifySupplierGstin",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/admin/suppliers/verify-gstin",
        payload
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "Failed to verify GSTIN");
    }
  }
);

export const verifySupplierBank = createAsyncThunk(
  "business/verifySupplierBank",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/admin/suppliers/verify-bank",
        payload
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "Failed to verify Bank Account");
    }
  }
);

export const editBusDets = createAsyncThunk(
  "business/editBusDets",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/editBusDets", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const sendOtp = createAsyncThunk(
  "business/sendOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/sendOtp", payload);
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const newEnquirySendOtp = createAsyncThunk(
  "business/newEnquirySendOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/kyc/sendOtp", payload);
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const validateOtp = createAsyncThunk(
  "business/validateOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/validateOtp", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const newEnquiryValidateOtp = createAsyncThunk(
  "business/newEnquiryValidateOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/kyc/validateOtp", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const adminEditValidateOtp = createAsyncThunk(
  "business/adminEditValidateOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/adminEditValidateOtp", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const editSendOtp = createAsyncThunk(
  "business/editSendOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/editSendOtp", payload);
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const busSendOtp = createAsyncThunk(
  "business/busSendOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/busSendOtp", payload);
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const busValidateOtp = createAsyncThunk(
  "business/busValidateOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/busValidateOtp", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const BusinessSlice = createSlice({
  name: "business",
  initialState: {
    loading: false,
    error: "",
    editOtpError: "",
    businessData: [],
    otpError: "",
    validateOtpLoading: false,
    busDetailedViewData: {},
    otpData: {},
    editOtpData: {},
    editSaveloading: false,
    editError: "",
  },

  extraReducers: (builder) => {
    builder.addCase(getBusinessView.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBusinessView.fulfilled, (state, action) => {
      state.loading = false;
      state.businessData = action.payload;
    });
    builder.addCase(getBusinessView.rejected, (state, action) => {
      state.loading = false;
      state.businessData = [];
    });

    builder.addCase(getBusDetailedView.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBusDetailedView.fulfilled, (state, action) => {
      state.loading = false;
      state.busDetailedViewData = action.payload;
    });
    builder.addCase(getBusDetailedView.rejected, (state, action) => {
      state.loading = false;
      state.busDetailedViewData = {};
    });

    builder.addCase(getBusinessSuppliers.fulfilled, (state, action) => {
      if (state.busDetailedViewData) {
        state.busDetailedViewData = {
          ...state.busDetailedViewData,
          suppliers: action.payload,
        };
      }
    });

    builder.addCase(sendOtp.pending, (state) => {
      state.otpError = "";
    });
    builder.addCase(sendOtp.fulfilled, (state, action) => {
      state.otpData = action.payload;
      state.otpError = "";
    });
    builder.addCase(sendOtp.rejected, (state, action) => {
      state.otpData = {};
      state.otpError = action.payload;
    });

    builder.addCase(newEnquirySendOtp.pending, (state) => {
      state.otpError = "";
    });
    builder.addCase(newEnquirySendOtp.fulfilled, (state, action) => {
      state.otpData = action.payload;
      state.otpError = "";
    });
    builder.addCase(newEnquirySendOtp.rejected, (state, action) => {
      state.otpData = {};
      state.otpError = action.payload;
    });

    builder.addCase(editSendOtp.pending, (state) => {
      state.editOtpError = "";
    });
    builder.addCase(editSendOtp.fulfilled, (state, action) => {
      state.editOtpData = action.payload;
      state.editOtpError = "";
    });
    builder.addCase(editSendOtp.rejected, (state, action) => {
      state.editOtpData = {};
      state.editOtpError = action.payload;
    });

    builder.addCase(validateOtp.pending, (state) => {
      state.validateOtpLoading = true;
      state.otpError = "";
    });
    builder.addCase(validateOtp.fulfilled, (state, action) => {
      state.validateOtpLoading = false;
      state.otpError = "";
    });
    builder.addCase(validateOtp.rejected, (state, action) => {
      state.validateOtpLoading = false;
      state.otpError = action.payload;
    });

    builder.addCase(newEnquiryValidateOtp.pending, (state) => {
      state.validateOtpLoading = true;
      state.otpError = "";
    });
    builder.addCase(newEnquiryValidateOtp.fulfilled, (state, action) => {
      state.validateOtpLoading = false;
      state.otpError = "";
    });
    builder.addCase(newEnquiryValidateOtp.rejected, (state, action) => {
      state.validateOtpLoading = false;
      state.otpError = action.payload;
    });

    builder.addCase(adminEditValidateOtp.pending, (state) => {
      state.validateOtpLoading = true;
      state.otpError = "";
    });
    builder.addCase(adminEditValidateOtp.fulfilled, (state, action) => {
      state.validateOtpLoading = false;
      state.otpError = "";
    });
    builder.addCase(adminEditValidateOtp.rejected, (state, action) => {
      state.validateOtpLoading = false;
      state.otpError = action.payload;
    });

    builder.addCase(editBusDets.pending, (state) => {
      state.editSaveloading = true;
      state.editError = "";
    });
    builder.addCase(editBusDets.fulfilled, (state, action) => {
      state.editSaveloading = false;
      state.editError = "";
    });
    builder.addCase(editBusDets.rejected, (state, action) => {
      state.editSaveloading = false;
      state.editError = action.payload;
    });

    builder.addCase(busSendOtp.pending, (state) => {
      state.otpError = "";
    });
    builder.addCase(busSendOtp.fulfilled, (state, action) => {
      state.otpData = action.payload;
      state.otpError = "";
    });
    builder.addCase(busSendOtp.rejected, (state, action) => {
      state.otpData = {};
      state.otpError = action.payload;
    });
    builder.addCase(busValidateOtp.pending, (state) => {
      state.validateOtpLoading = true;
      state.otpError = "";
    });
    builder.addCase(busValidateOtp.fulfilled, (state, action) => {
      state.validateOtpLoading = false;
      state.otpError = "";
    });
    builder.addCase(busValidateOtp.rejected, (state, action) => {
      state.validateOtpLoading = false;
      state.otpError = action.payload;
    });
  },

  reducers: {
    updateOtpErrorStatus(state) {
      state.otpError = "";
    },
    clearBusError(state) {
      state.error = "";
      state.editError = "";
      state.editOtpError = "";
    },
  },
});

export const { updateOtpErrorStatus, clearBusError } = BusinessSlice.actions;

export default BusinessSlice.reducer;
